module.exports = __webpack_public_path__ + "img/lotus-logo.e84ae104.png";